module.exports = __webpack_public_path__ + "static/media/emirates-card.38d8720c.svg";